

import {Component, Vue} from "vue-property-decorator"
import {Verslagen} from "@/types/Verslagen";
import JaarverslagenListNL from "@/components/layout/JaarverslagenListNL.vue";
import JaarverslagenListFR from "@/components/layout/jaarverslagenListFR.vue";


@Component({
    components: {JaarverslagenListFR, JaarverslagenListNL}
})
export default class Jaarverslagen extends Vue {
    name!: "Jaarverslagen"

    // TODO FIX BEFORE PRODUCTION
    jaarverslagenlink = "/jaarverslagen/"

    verslagen: Array<Verslagen> = [
        {
            jaar: 2016,
            name: "2016",
            language: "nl",
            link: "2016NL.pdf"
        }, {
            jaar: 2017,
            name: "2017",
            language: "nl",
            link: "2017NL.pdf"
        }, {
            jaar: 2018,
            name: "2018",
            language: "nl",
            link: "2018NL.pdf"
        }, {
            jaar: 2019,
            name: "2019",
            language: "nl",
            link: "2019NL.pdf"
        }, {
            jaar: 2016,
            name: "2016",
            language: "fr",
            link: "2016FR.pdf"
        }, {
            jaar: 2017,
            name: "2017",
            language: "fr",
            link: "2017FR.pdf"
        }, {
            jaar: 2018,
            name: "2018",
            language: "fr",
            link: "2018FR.pdf"
        }, {
            jaar: 2019,
            name: "2019",
            language: "fr",
            link: "2019FR.pdf"
        }, {
            jaar: 2020,
            name: "2020",
            language: "nl",
            link: "2020NL.pdf"
        }, {
            jaar: 2020,
            name: "2020",
            language: "fr",
            link: "2020FR.pdf"
        }, {
            jaar: 2021,
            name: "2021",
            language: "nl",
            link: "2021NL.pdf"
        }, {
            jaar: 2021,
            name: "2021",
            language: "fr",
            link: "2021FR.pdf"
        }, {
            jaar: 2022,
            name: "2022",
            language: "nl",
            link: "2022NL.pdf"
        }, {
            jaar: 2022,
            name: "2022",
            language: "fr",
            link: "2022FR.pdf"
        }, {
            jaar: 2023,
            name: "2023",
            language: "nl",
            link: "2023NL.pdf"
        }, {
            jaar: 2023,
            name: "2023",
            language: "fr",
            link: "2023FR.pdf"
        }, {
            jaar: 2024,
            name: "2024",
            language: "nl",
            link: "2024NL.pdf"
        }, {
            jaar: 2024,
            name: "2024",
            language: "fr",
            link: "2024FR.pdf"
        }, {
            jaar: 2025,
            name: "2025",
            language: "nl",
            link: "2025NL.pdf"
        }, {
            jaar: 2025,
            name: "2025",
            language: "fr",
            link: "2025FR.pdf"
        }
    ].sort((verslag1, verslag2) => verslag2.jaar - verslag1.jaar)

}
